import createStyled from '../createStyled';
import createWithSkeleton from '../hoc/withSkeleton';
import spacing from '../styles/spacing';
import typography from '../styles/typography';
import background from '../styles/background';
import color from '../styles/color';
import visibility from '../styles/visibility';
import containerType from '../styles/containerType';
import containerName from '../styles/containerName';

const Text = createStyled('span', 'Text')(
  typography,
  visibility,
  spacing,
  containerType
)(background, color, containerName);

export default createWithSkeleton(Text);
